import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, FileText } from "lucide-react";
import { Card, CardContent } from "../../../components/ui/card";
import { Button } from "../../../components/ui/button";

const SECTIONS = [
  {
    title: "1. Aceptación de los términos",
    body: `Al acceder y utilizar el sitio web y la plataforma educativa de I.E.P. San Isidro, aceptas los presentes Términos de Servicio. Si no estás de acuerdo con alguno de ellos, te pedimos no utilizar la plataforma.`,
  },
  {
    title: "2. Uso de la plataforma",
    body: `La plataforma está destinada a estudiantes matriculados, padres o apoderados y docentes de I.E.P. San Isidro para fines educativos y administrativos. Queda prohibido su uso para fines distintos a los previstos, así como compartir credenciales de acceso con terceros.`,
  },
  {
    title: "3. Cuentas de usuario",
    body: `Cada usuario es responsable de mantener la confidencialidad de sus credenciales de acceso y de todas las actividades realizadas desde su cuenta. Debes notificarnos de inmediato ante cualquier uso no autorizado de tu cuenta.`,
  },
  {
    title: "4. Contenido y propiedad intelectual",
    body: `Los materiales educativos, textos, imágenes y demás contenidos publicados en la plataforma son propiedad de I.E.P. San Isidro o de sus respectivos titulares, y no pueden ser reproducidos, distribuidos o comercializados sin autorización previa.`,
  },
  {
    title: "5. Conducta del usuario",
    body: `Los usuarios se comprometen a hacer un uso respetuoso y responsable de la plataforma, absteniéndose de publicar contenido ofensivo, difamatorio o que infrinja derechos de terceros, así como de intentar vulnerar la seguridad del sistema.`,
  },
  {
    title: "6. Disponibilidad del servicio",
    body: `I.E.P. San Isidro procura mantener la plataforma disponible de forma continua, pero no garantiza un funcionamiento ininterrumpido y podrá suspender el acceso temporalmente por mantenimiento o causas de fuerza mayor.`,
  },
  {
    title: "7. Limitación de responsabilidad",
    body: `I.E.P. San Isidro no será responsable por daños indirectos derivados del uso o la imposibilidad de uso de la plataforma, salvo en los casos previstos por la normativa aplicable.`,
  },
  {
    title: "8. Modificaciones",
    body: `Nos reservamos el derecho de modificar estos Términos de Servicio en cualquier momento. Los cambios entrarán en vigencia desde su publicación en esta página.`,
  },
  {
    title: "9. Contacto",
    body: `Ante cualquier duda sobre estos Términos de Servicio, puedes escribirnos a informes@iepsanisidro.edu.pe o comunicarte al +51 941 699 392.`,
  },
];

export function TermsOfService() {
  const navigate = useNavigate();

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, []);

  return (
    <div className="bg-[#fdf6f0]">
      <div className="mx-auto max-w-3xl px-4 pb-16 pt-24">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => navigate("/")}
          className="mb-4 text-[#4a321c] hover:bg-[#4a321c]/10"
        >
          <ArrowLeft className="h-4 w-4" />
          Volver al inicio
        </Button>

        <div className="mb-8 flex items-center gap-3">
          <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-[#4a321c]/10 text-[#4a321c]">
            <FileText className="h-6 w-6" />
          </div>
          <div>
            <h1 className="font-heading text-2xl font-bold text-[#4a321c] sm:text-3xl">
              Términos de Servicio
            </h1>
            <p className="text-sm text-gray-500">I.E.P. San Isidro</p>
          </div>
        </div>

        <Card className="border border-[#e6d5ba] bg-white shadow-md">
          <CardContent className="space-y-6 p-6 md:p-8">
            <p className="text-sm leading-relaxed text-gray-600">
              Estos Términos de Servicio regulan el acceso y uso del sitio web
              y la plataforma educativa de I.E.P. San Isidro por parte de
              estudiantes, padres de familia, apoderados y docentes.
            </p>

            {SECTIONS.map((section) => (
              <div key={section.title}>
                <h2 className="mb-2 text-base font-bold text-[#4a321c]">
                  {section.title}
                </h2>
                <p className="text-sm leading-relaxed text-gray-600">
                  {section.body}
                </p>
              </div>
            ))}

            <p className="pt-2 text-xs text-gray-400">
              Última actualización: agosto de 2026.
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
